import React from "react";
import "./custom.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom() {
    return(
        <div className="customContainer">
            <div className="titleBlock" id="verticalInflate">
                    Custom Marquetry By Commission
            </div>
            <div className="imageContainer">
                <img src="./images/misc/handWork2.jpg" className="titleImage" alt="Very detailed artwork showing the top of a wooden boat" data-aos="fade" data-aos-duration="2500" />
            </div>
            <br></br>
            <div className="textContent">
                <p>
                    If you are curious about having custom artwork made in wood marquetry, getting an estimate is simple. Click the link below for a tour of the process.
                </p>
            </div>
            <a href="/custom2">
                <div className="imageContainer">
                    <button className="tour" data-aos="fade" data-aos-duration="3000">
                        Take a tour
                    </button>
                </div>
            </a>
            <div className="textContent">
                <p>
                    Or, scroll down to see several examples of commission work I have done.
                </p>
            </div>
            <div className="imageContainer">
                <img className="arrow" src="./images/misc/arrowDown.gif" alt="Cue to scroll down for more content." />
            </div>
            <div>
                <br></br><br></br>
                <h5 className="titleBlock">
                    Custom work with original photos
                </h5>
            </div>
            <br></br>
            <div className="textContent">
                <p>
                    This is a good example of a boat with moderate detail showing on the boat, but no significant background.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/commission1.jpg" className="artAndOriginal" alt="Artwork with moderate boat detail. But, very little background detail" data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br>
                <p>
                    Here is an example of a scene with several complex objects in abundant detail. This took a very long time to complete.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/broughtonFull.jpg" className="artAndOriginal" alt="Artwork with an enourmous amount of detail that took a long time to create." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br><br></br>
                <p>
                    This piece was difficult to source just the right woods to create the aged grey dock and other highly unique woods with just the right grain patterns.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/alexFull.jpg" className="artAndOriginal" alt="Beautiful antique wooden boat tied to an old grey dock." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br>
                <p>
                    There is only one way to know the exact price of recreating your favorite photograph into marquetry. Send in a few images and I can reply with several pricing options so that you can pick what best matches your needs.
                    It is a quick and easy way to indulge your curiosity, and there is no obligation.
                    send digital images to:  bing.inlay@gmail.com
                </p>
                <br></br><br></br>
                <p>
                    This next piece came from a lady who I met at a classic boat show in Lake Geneva, Wisconsin. She knew her husband enjoyed my work from the many examples I had displayed. She wanted to get him something very special for Christmas.
                </p>
                <p>
                    She mentioned that she had a photograph of his boyhood home, and a 1956 Thunderbird that his dad owned and he later inherited. I was asked if I could make a picture with the car parked in front of the house. I agreed. He was very touched by the gift since both things had so much meaning for him.
                </p>
                <p>
                    Here are the photos I was given:
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/commission2.jpg" className="artAndOriginal" alt="Original shot of the home he grew up in." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br>
                <p>
                    This is what I created from those original photos...
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/commission2a.jpg" className="customArtwork" alt="The final artwork with the car partked in front of the house." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br>
                <p>
                    This piece is of a lighthouse on Beaver Island, Michigan. The lady for whom it was commissioned lived on Beaver Island for a decade, or so. She wanted something made that reminded her of the time she spent there. She sent photographs of a lighthouse, a tugboat that she owned while she was there, and the Beaver Island ferry. After giving her all of the pricing options, she chose to have the lighthouse made.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/commission3.jpg" className="artAndOriginal" alt="Artwork created of the Beaver Island lighthouse." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br>
                <p>
                    These are a pair of perpetual awards plaques that I made for a Michigan boat show. They are both about 1.5 inches thick.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/commission4a.jpg" className="customArtwork" alt="Award plaques" data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br>
                <p>
                    This is a 12 foot long mural made up of 3 panels. The customer wanted to mount them on the outside of his home in Washington. The scene depicts the view he has around his home. We had an agreement that I would put the best weather-proof finish on the mural, but could not warranty it from damage as my work is meant to be interior. I received some tips from local woodworkers that I passed on to him for regular maintenance that could help preserve it long-term.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/fullMural.jpg" className="mural" alt="Full mural made of 3 pieces." data-aos="fade" data-aos-duration="2500" />
            </div>
            <br></br>
            <div className="imageContainer">
                <img src="./images/commission/muralFull.jpg" className="artAndOriginal" alt="This is the installation of the mural artwork." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br><br></br><br></br>
                <p>
                    This donor plaque was made for the Grand Haven, MI library.
                </p>
            </div>
            <div className="imageContainer">
                <img src="./images/commission/grandhavenplaque.jpg" className="customArtwork" alt="Library plaque." data-aos="fade" data-aos-duration="2500" />
            </div>
            <br></br>
            <div className="imageContainer">
                <img src="./images/commission/grandhavenplaque2.jpg" className="customArtwork" alt="Library plaque being installed by artist." data-aos="fade" data-aos-duration="2500" />
            </div>
            <div className="textContent">
                <br></br>
                <p>
                    Send in your photographs now for a free price quote!

                    bing.inlay@gmail.com
                </p>
            </div>
            <br></br><br></br>
        </div>
        
    );
};


export default Custom